import { useQuery } from "@apollo/client";
import Loading from "shared/components/Loading";
import graphql from "utils/api/graphql";
import { useNavigate } from "react-router-dom";
import { PRODUCT_TYPES, SCREENS } from "utils/constants";
import { useEffect } from "react";
import { isNil, get } from "lodash";

function Trace() {
  const navigate = useNavigate();
  const { data } = useQuery(graphql.queries.PRODUCT, {
    variables: {
      where: {
        type: PRODUCT_TYPES.BTC_AIRDROP.value,
      },
    },
  });

  useEffect(() => {
    const applyTrace = () => {
      const product = get(data, "product");
      if (!isNil(product))
        return navigate(SCREENS.PRIVATE.ORGANIZATION.ORDINALS.LIST, {
          state: { product: { id: product.id } },
        });
    };
    return applyTrace();
  }, [data, navigate]);

  return <Loading />;
}

export default Trace;
